import type {
    Asset,
    Block,
    NodeBaseMixin,
    Page,
    Rendition,
    Story
} from '#magnolia-layer/types/magnolia-types';
import {isArea, isAsset} from "../types/api";

const deepFindImage = (n: NodeBaseMixin<any>, imageKey: string): Asset | null => {
    const nodes = (n["@nodes"] || []).map(k => n[k] as NodeBaseMixin<any>);
    for (const node of nodes) {
        if (Object.hasOwnProperty.call(node, imageKey)) {
            const candidate = node[imageKey];
            if (isAsset(candidate)) {
                return candidate;
            }
        }
        const result = deepFindImage(node, imageKey);
        if (result !== null) {
            return result;
        }
    }
    return null;
}

// ONLY ON SERVER / SSG
export const findFirstImage = (root: Page, imageKey: string): Asset | null => {
    // First check header, then main in that order. After check any additional areas on the page.
    const areas = new Set<string>(['header', 'main']);
    root['@nodes'].forEach(n => areas.add(n));
    for (const areaKey of areas) {
        const area = root[areaKey];
        if (!isArea(area)) {
            continue;
        }
        const result = deepFindImage(area, imageKey);
        if (result != null) {
            return result;
        }
    }
    return null;
}

export const findFirstImageStory = (root: Story, imageKey: string): Asset | null => {
    // First check header, then main in that order. After check any additional areas on the page.
    const blocks = root.blocks['@nodes'];
    for (const blockKey of blocks) {
        const block: Block | undefined = root.blocks[blockKey];
        if (!block) continue;
        if (block['mgnl:type'] !== 'image') {
            continue;
        }
        const result = block.image;
        if (result != null && isAsset(result)) {
            return result;
        }
    }
    return null;
}


export const findRenditionOnNodeProperties = (root: NodeBaseMixin<string>, property: string, rendition: string): Rendition | null => {
    const asset = findAssetOnNodeProperties(root, property);
    if (isAsset(asset)) {
        const _rendition = asset.renditions?.[rendition];
        if (_rendition != undefined) {
            return _rendition;
        }
    }
    return null;
}

export const findAssetOnNodeProperties = (root: NodeBaseMixin<string>, property: string): Asset | null => {
    const prop = root[property];
    if (isAsset(prop)) {
        return prop;
    }
    return null;
}
